<template>
  <v-layout row wrap>
    <v-dialog
      v-model="syncloading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by syncing WA Data
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-flex xs12>
      <v-card class="elevation-6">
        <v-btn @click="picMessage()" :disabled="single" small absolute top right fab color="secondary" dark>
            <v-icon>sync</v-icon>
          </v-btn>
          <v-btn @click="dialog = true" :disabled="single" small absolute top left fab color="secondary" dark>
            <v-icon>add</v-icon>
          </v-btn>
        <v-dialog v-model="dialog" persistent max-width="420">
          <v-card>
            <v-card-title class="headline">Send a message to a new contact</v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Number"
                    v-model="nNumber"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Message"
                    v-model="nSMessage"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" outline @click="dialog = false">cancel</v-btn>
              <v-btn 
                color="success" 
                @click="sendToNewNumber()"
              >Send</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-select
          :items="myNumbers"
          solo
          class="chatF"
          return-object
          :disabled="sending || single"
          v-model="selectedMyNumber"
          label="Select A Whatsapp"
        ></v-select>
        <v-autocomplete
          :items="contactedNumbers"
          solo
          class="chatF"
          return-object
          clearable
          :disabled="sending || single"
          v-model="selectedNumberChat"
          label="Select A Contact"
        ></v-autocomplete>
        <v-layout row wrap>
          <!-- <v-flex xs2>
            <virtual-list :size="40" :remain="8">
              <div v-for="t in [
                {id:1},
                {id:2},
                {id:3},
                {id:4},
              ]" :key="t">{{ t }}</div>
            </virtual-list>
          </v-flex> -->
          <v-flex xs2 pa-2>
            <v-layout row wrap>
              <v-flex xs12>
                Filter By Status
                <v-autocomplete
                  :items="waStatuses"
                  v-model="selectedWAStatusFilter"
                  label="Filter By Status"
                  return-object
                  clearable
                  hide-details
                  @change="filterWAByStatus()"
                  :loading="statusLoading"
                  :disabled="!selectedMyNumber || single"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 pt-3 >
                <v-divider class="pb-2"></v-divider>
                Select a Status
                <v-autocomplete
                  :items="waStatuses"
                  v-model="selectedWAStatus"
                  label="Select a Status"
                  return-object
                  clearable
                  hide-details
                  :append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
                  @click:append-outer="addWAStatusdialog = true"
                  :loading="statusLoading"
                  :disabled="!selectedMyNumber || !selectedNumberChat  || single"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-btn 
                  :disabled="!selectedWAStatus || !selectedMyNumber || !selectedNumberChat || single" 
                  @click="storeWAStatus()" 
                  outline 
                  color="primary" 
                  small 
                  block 
                  :loading="statusLoading"
                >save</v-btn>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="['1', '2', '7', '14', '28', '60', '90']"
                  v-model="period"
                  label="Sync Period"
                  :disabled="single"
                ></v-select>
                <v-btn @click="picMessage()" :disabled="single" small block color="info" dark>
                  <v-icon left>sync</v-icon> sync contacts
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10>
            <div v-chat-scroll="{always: false, smooth: true}" class="chat-container">
              <v-layout row wrap>
                <v-flex  v-for="msg in chatMessages" :key="msg.time + msg.idgen" :class="` ${(msg.own?'text-xs-right':'')}`" xs12>
                  <v-layout row wrap>
                    <v-flex xs12>
                    </v-flex>
                    <v-flex xs12>
                      <v-icon clas="cStat" size="15px" v-if="msg.sent && !msg.delivered">done</v-icon>
                      <v-icon clas="cStat" size="15px" v-if="msg.delivered && !msg.viewed">done_all</v-icon>
                      <v-icon clas="cStat" size="15px" v-if="msg.viewed" color="primary">done_all</v-icon>
                      <div :class="`chatBubble ${(msg.own?'ownBub':'')}`" >
                        <v-tooltip top>
                          <div slot="activator" style="font-size:8px">{{ new Date(parseInt(msg.time + '000')) .toLocaleString('en-GB') }} | {{msg.user}}</div>
                          <span>{{ new Date(parseInt(msg.time + '000')) .toLocaleString('en-GB') }}  | {{msg.user}}</span>
                        </v-tooltip>
                          <div v-if="msg.body && !msg.body.includes('firebase')">{{msg.body}}</div>
                          <div v-else-if="msg.body 
                          && msg.body.includes('firebase') 
                          && !msg.body.includes('oga')
                          && !msg.body.includes('mp4')">
                            <img :src="msg.body"  width="350px"><div>{{msg.caption}}</div></div>
                          <div v-else>
                            <video width="350"  controls>
                              <source :src="msg.body" >
                            </video>
                            <div>{{msg.caption}}</div></div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex 
                  v-if="chatMessages.length != 0 
                  && chatMessages[chatMessages.length-1].fromme == 'False' 
                  && !chatMessages[chatMessages.length-1].read" 
                  xs12 class="justify-center text-xs-center">
                  <v-btn @click="markAsRead()" outline color="primary" dark>mark as read</v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <div v-if="imgURL" class="imagePreview" >
            
            <div style="position:absolute;z-index:19000;">
              <v-btn @click="removeImage" color="error" icon>
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <img v-if="!imgURL.includes('mp4')" class="imageItself" :src="imgURL">
            <video v-else width="200"  controls>
              <source :src="imgURL" >
            </video>
          </div>
        </v-layout>   
        <div>
          <input
            type="file"
            style="display: none"
            ref="file"
            accept="csv/*"
            @change="onFilePicked"
          >
          <v-text-field 
            solo 
            :loading="loading"
            class="chatF"
            height="60"
            label="...." 
            v-model="sMessage"
            prepend-inner-icon="add_photo_alternate"
            @click:prepend-inner="addImage()"
            append-icon="send"
            @click:append="sendMessage()"
            @keyup.enter="sendMessage()"
          ></v-text-field>
        </div>
      </v-card>
    </v-flex>
    <v-dialog fullscreen v-model="dialogs.qr" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">Please Scan QR</v-card-title>
          <v-card-text class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12>
                <img :src="qrCode">
              </v-flex>
              <v-flex xs12>
                <v-btn outline color="primary" @click="checkWA()" dark>Scan Then Click here</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-progress-circular indeterminate v-if="loading" color="primary"></v-progress-circular>
            <v-spacer></v-spacer>
            <v-btn outline color="error" @click="dialogs.qr = null">{{ qrCode ? 'cancel' : 'close' }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="addWAStatusdialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">You want to add a new status?</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  label="Status"
                  required
                  v-model="newWAStatus"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="addWAStatusdialog = false">Cancel</v-btn>
            <v-btn :disabled="!newWAStatus" color="green darken-1" flat @click="addWAStatus()">add</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-layout>
</template>

<script>
import Papa from 'papaparse'
import axios from 'axios';
import { uuid } from '@/customFunction';
import virtualList from 'vue-virtual-scroll-list'
import { storageRef, firebase, db, auth } from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';

export default {
  components: {
    'virtual-list': virtualList,
  },
  data() {
    return {
      url:null,
      dialog:false,
      dialogs:{
        qr:false
      },
      name:null,
      file:null,
      loading:false,
      sNumber:null,
      sMessage:null,
      csv:null,
      sending:false,
      qrCode:null,
      qr:null,
      messagesH:[],
      messages:[],
      detailedViewsHeaders:[],
      detailedViews:[],
      contacts:[],
      contactedNumbers:[],
      selectedNumber:null,
      selectedNumberChat:null,
      chatMessages:[],
      myMSGS:[],
      clientMSGS:[],
      nNumber:null,
      fName:null,
      lName:null,
      nSMessage:null,
      myNumbers:[],
      selectedMyNumber:null,
      syncloading:false,
      realLsner: null,
      lsnrTopN: null,
      lsnrLowN: null,
      waStatuses: [],
      selectedWAStatus: null,
      addWAStatusdialog: null,
      newWAStatus: null,
      statusLoading:false,
      contactedNumbersLoaded:[],
      selectedWAStatusFilter: null,
      file: null,
      uploadURL: null,
      fileName:null,
      imgURL: null,
      imgURLExt: null,
      period:'2',
      single:false
    }
  },
  methods: {
    markAsRead() {
      let lastmsgID = this.chatMessages[this.chatMessages.length-1].key
      db.ref(`whatsapp/${this.selectedMyNumber}/${this.selectedNumberChat.value}/messages/${lastmsgID}`)
      .update({
        read:true
      })
      .then(x=>{
        db.ref(`whatsapp/${this.selectedMyNumber}/${this.selectedNumberChat.value}/`)
        .update({
          need:false,
          was: {
            need:false
          }
        })
      })
    },
    async sendToNewNumber(){
      
      this.dialog = false
      if(this.lsnrTopN && this.lsnrLowN && this.realLsner) {
          db.ref(`whatsapp/${this.lsnrTopN}/${this.lsnrLowN}`).off('value', this.realLsner)
        }
      this.chatMessages = []
      this.loading = false
      this.loading = true
      this.sending = true
      let n = await db.ref(`settings/wa/${this.selectedMyNumber}`)
      .once('value')
      .then(x=>x.val())
      await axios.get(`${n.instance}status?token=${n.token}`)
      .then(resp => {
        if (resp.data.qrCode) {
          this.dialogs.qr = true
          this.loading = false
          this.qrCode = resp.data.qrCode
          this.$emit('snackbarNotification', `Please scan ${this.selectedMyNumber} QR code`, 'success')
        } else if(resp.data.accountStatus == 'authenticated'){
          this.dialogs.qr = false
          this.qrCode = null
          this.$emit('snackbarNotification', `Ready to send`, 'success')
          var headers = {
            'Accept': 'application/json'
          }
          let post = {
              phone:parseInt(this.nNumber),
              body:this.nSMessage
            }
            axios.post(`${n.instance}sendMessage?token=${n.token}`, post, {headers: headers})
            .then(resp=>{
              if (resp.data.sent) {
                this.sending = false
                this.sMessage = null
                this.nNumber = null
                this.nSMessage = null
                this.loading = false
                this.picMessage()
              }
            })
        } else {
          this.loading = false
          this.$emit('snackbarNotification', `Please Login to chat-api.com and click USE HERE`, 'success')
          setTimeout(x=>{
            window.open('https://app.chat-api.com/')
          }, 2000)
        }
      })
    },
    async sendMessage(){
      if (!this.selectedNumberChat.value || !this.sMessage) {
        return
      }
      this.loading = true
      this.sending = true
      let n = await db.ref(`settings/wa/${this.selectedMyNumber}`)
      .once('value')
      .then(x=>x.val())
      axios.get(`${n.instance}status?token=${n.token}`)
      .then(resp => {
        if (resp.data.qrCode) {
          this.dialogs.qr = true
          this.loading = false
          this.qrCode = resp.data.qrCode
          this.$emit('snackbarNotification', `Please scan ${this.selectedMyNumber} QR code`, 'success')
        } else if(resp.data.accountStatus == 'authenticated'){
          this.dialogs.qr = false
          this.qrCode = null
          this.$emit('snackbarNotification', `Ready to send`, 'success')
          var headers = {
            'Accept': 'application/json'
          }
          if(!this.imgURL) {
            let post = {
              phone:parseInt(this.selectedNumberChat.value),
              body:this.sMessage
            }
            axios.post(`${n.instance}sendMessage?token=${n.token}`, post, {headers: headers})
            .then(resp=>{
              if (resp.data.sent) {
                console.log(resp.data)
                db.ref(`WAuser`)
                .update({
                  [resp.data.id.replace('@c.us_', '').replace('@g.us_', '')]:this.$props.userName
                })
                let uid = uuid()
                this.sending = false
                this.sMessage = null
                this.loading = false
              }
            })
          } else {
            let post = {
              phone:parseInt(this.selectedNumberChat.value),
              body:this.imgURL,
              filename:'ashyaat' + this.imgURLExt,
              caption:this.sMessage
            }
            axios.post(`${n.instance}sendFile?token=${n.token}`, post, {headers: headers})
            .then(resp=>{
              if (resp.data.sent) {
                console.log(resp.data)
                db.ref(`WAuser`)
                .update({
                  [resp.data.id.replace('@c.us_', '').replace('@g.us_', '')]:this.$props.userName
                })
                let uid = uuid()
                this.sending = false
                this.sMessage = null
                this.imgURL = null
                this.imgURLExt = null
                this.loading = false
              }
            })
          }
          
        } else {
          this.loading = false
          this.$emit('snackbarNotification', `Please Login to chat-api.com and click USE HERE`, 'success')
          setTimeout(x=>{
            window.open('https://app.chat-api.com/')
          }, 2000)
        }
      })
    },
    picMessage(){
      if(!this.selectedMyNumber) {
        this.$emit('snackbarNotification', `Please choose your WA Number`, 'error')
        return
      }
      this.syncloading = true
      this.period = this.period ? this.period : '2'
      axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/main/waChat?number=${this.selectedMyNumber}&period=${this.period}`)
      .then(resp=>{
        console.log('------------------------------------');
        console.log(resp.data.contactedNumbers);
        console.log('------------------------------------');
        this.contacts = resp.data.contacts
        this.contactedNumbers = resp.data.contactedNumbers
        this.contactedNumbersLoaded = resp.data.contactedNumbers
        this.filterWAByStatus()
        this.syncloading = false
      })
    },
    getNumbers(){
      db.ref('settings/wa')
      .once('value')
      .then(x=>{
        this.myNumbers = Object.keys(x.val())
      })
    },
    filterWAByStatus(){
      if(!this.selectedMyNumber) return
      if(!this.selectedWAStatusFilter) {
        this.contactedNumbers = this.contactedNumbersLoaded; 
        return;
      }
      this.contactedNumbers = this.contactedNumbersLoaded.filter(x=> x.status == this.selectedWAStatusFilter)
    },
    chat(){
      this.loading = true
      if(!this.selectedNumberChat){
        if(this.lsnrTopN && this.lsnrLowN && this.realLsner) {
          db.ref(`whatsapp/${this.lsnrTopN}/${this.lsnrLowN}`).off('value', this.realLsner)
        }
        this.chatMessages = []
        this.loading = false
        return
      }
      let sContact = this.contacts.filter(c => c.number == this.selectedNumberChat.value)[0]
      if(this.lsnrTopN && this.lsnrLowN && this.realLsner) {
        db.ref(`whatsapp/${this.lsnrTopN}/${this.lsnrLowN}`).off('value', this.realLsner)
      }
      this.lsnrTopN = this.selectedMyNumber
      this.lsnrLowN = this.selectedNumberChat.value
      this.realLsner = 
      db.ref(`whatsapp/${this.selectedMyNumber}/${this.selectedNumberChat.value}`)
      .on('value', c=>{
        this.chatMessages = []
        let contact = c.val()
        console.log(contact)
        this.selectedWAStatus = contact.status
        let messages = contact.messages
        for (const key in messages) {
          if (messages.hasOwnProperty(key)) {
            const message = messages[key];
            message.key = key
            message.idgen = uuid()
            this.chatMessages.push(message)
          }
        }

        let ownmsgs = this.chatMessages.filter(msg=> msg.fromme == "True")
        ownmsgs.forEach(x=>{
          x.own = true
        })
        this.loading = false
      })
    },
    storeWAStatus(){
      if(!this.selectedMyNumber && !this.selectedNumberChat.value && !this.selectedWAStatus) return
      this.statusLoading = true
      db.ref(`whatsapp/${this.selectedMyNumber}/${this.selectedNumberChat.value}/`)
      .update({
        status:this.selectedWAStatus
      })
      .then(x=>{
        this.statusLoading = false

      })
    },
    addWAStatus(){
      db.ref(`wastatuses`).push({
        name:this.newWAStatus
      })
      .then(x=>{
        this.addWAStatusdialog = false
      })
    },
    getWAStatuses(){
      db.ref(`wastatuses`).once('value')
      .then(x=>{
        let ss = x.val()
        for (const key in ss) {
          if (ss.hasOwnProperty(key)) {
            const s = ss[key];
            this.waStatuses.push(s.name)
          }
        }
      })
    },
    addImage(){
      console.log('s')
      this.pickFile()
    },
    pickFile() {
      this.$refs.file.click()
    },
    loadFile(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ashyaat' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.upload = progress
                }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          console.log('File available at', downloadURL);
          this.uploadURL = downloadURL
          this.imgURL = downloadURL
          this.loading = false
        });
      });
    },
    onFilePicked (e) {
      this.loading = true
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          console.log(this.file)
          this.imgURLExt = `.${this.file.name.split('.').pop()}`
          this.loadFile(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.fileName = null
        this.uploadURL = null
      }
    },
    removeImage(){
      this.imgURL = null
      this.imgURLExt = null
    },
    async getSingle(n){
      this.syncloading = true
      let numbers = await db.ref('settings/wa').once('value').then(x=>Object.keys(x.val()));
      (async ()=>{
        for (let i = 0; i < numbers.length && !this.selectedMyNumber; i++) {
          const num = numbers[i];
          let c = await db.ref(`whatsapp/${num}/${n}`).once('value').then(c=>c.val())
          if(c) {
            this.selectedMyNumber = num
            let cont = {
              text:n,
              value:n,
              key:n
            }
            this.contactedNumbers.push(cont)
            this.contactedNumbersLoaded.push(cont)
            this.selectedNumberChat = cont
            this.chatMessages = []
            let contact = c
            console.log(contact)
            this.selectedWAStatus = contact.status
            let messages = contact.messages
            for (const key in messages) {
              if (messages.hasOwnProperty(key)) {
                const message = messages[key];
                message.key = key
                message.idgen = uuid()
                this.chatMessages.push(message)
              }
            }

            let ownmsgs = this.chatMessages.filter(msg=> msg.fromme == "True")
            ownmsgs.forEach(x=>{
              x.own = true
            })
            this.chat()
            this.loading = false
          }
        }
        this.syncloading = false
      })()
    },
  },
  props: {
    userName: {
      required: true,
      default: 'user'
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
  },
  watch:{
    selectedNumberChat(){
      this.imgURL = null
      this.imgURLExt = null
      if(!this.single){
        this.chat()
      }
    },
    selectedMyNumber(){
      this.imgURL = null
      this.imgURLExt = null
      if(!this.single){
        this.picMessage()
      }
    }
  },
  created() {
    if(this.$route.params) {
      console.log(this.$route.params.number)
    }
    this.getNumbers()
    this.getWAStatuses()
    let p = this.$route.params
    if(p && p.number) {
      this.single = true
      this.getSingle(p.number)
    } 
  },
  
}
</script>

<style>
.chat-container {
  box-sizing: border-box;
  height: calc(100vh - 20.7rem);
  overflow-y: auto;
  padding: 10px;
  background-color: #f2f2f2;
  box-shadow: inset 0px 0px 3px rgba(0, 0, 0, 0.65);

}
.chatF .v-input__slot {
  margin-bottom:0 !important;
}
.chatF .v-text-field__details {
  display: none
}

.chatBubble {
  padding: 8px;
  background-color: #90ee90;
  border-radius: 10px;
  display: inline-block;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12);
  max-width: 50%;
  word-wrap: break-word;
  margin-bottom: 4px
}

.ownBub {
  background-color: #FFEB3B;
}
.ownMsg {
  text-align: right;
}

.cStat {
  margin-right: 6px !important;
}
.imagePreview {
  border-radius: 3px;
  bottom: 53px;
  width: 200px;
  position: absolute;
  z-index: 101010;
  right: 20px;
  box-shadow: 0 0 4px black;
}
.imageItself {
  width: 200px;
  border-radius: 3px;

}
</style>
